export const truncateToTwoDecimals = (value = 0) => {
	return Math.trunc(value * 100) / 100
}